/* ============================================================
   Maven — pagina de produto «mono»: mostrar a foto certa
   ------------------------------------------------------------
   Na grelha antiga viam-se todas as fotos ao mesmo tempo, por isso o nome
   escrito nas costas aparecia logo. Aqui so se ve uma foto de cada vez: quem
   escreve o nome nao ve nada acontecer, porque a camada esta na foto de tras.
   Este ficheiro trata disso — escreve-se o nome, a galeria vai as costas;
   escolhe-se um emblema, volta a frente.
   Nao toca na personalizacao: so carrega na miniatura que ja existe.
   ============================================================ */
(function () {
  'use strict';

  function miniaturas() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.product-thumbnail-container .product-thumbnail')
    );
  }

  /* Qual e a foto de tras? A que o proprio JS da personalizacao marcou com a
     camada do nome. Se ainda nao houver camada, vale o nome do ficheiro. */
  function indiceCostas() {
    var media = document.querySelectorAll('.product-single__media');
    for (var i = 0; i < media.length; i++) {
      if (media[i].querySelector('.mvn-costas__camada')) return i;
    }
    for (var j = 0; j < media.length; j++) {
      var img = media[j].querySelector('img');
      var src = img ? (img.getAttribute('src') || '') : '';
      if (/back|costas|tras/i.test(src)) return j;
    }
    return -1;
  }

  function indiceFrente() { return 0; }

  var ultimo = -1;
  function mostrar(i) {
    if (i < 0 || i === ultimo) return;
    var minis = miniaturas();
    if (!minis[i]) return;
    ultimo = i;
    minis[i].click();
    acertar();
    setTimeout(acertar, 450);
  }

  /* O carrossel (flickity) mede-se quando e construido. Se o formulario for
     repintado a seguir — e e, porque a variante mudou — ele fica com a conta
     velha e a foto aparece **a cavalo entre dois slides**, como se tivesse
     descido. Visto no PSG a 22/08 ao escolher um jogador.
     Um `resize` da janela nao chega (aproxima, nao acerta). Sao precisos os
     dois: medir outra vez e voltar a assentar no slide escolhido, sem
     animacao. Conferido: alinha ao pixel. */
  function acertar() {
    try {
      var el = document.querySelector('product-slider-thumbnails, product-slider');
      if (!el || !window.Flickity) return;
      var f = window.Flickity.data(el);
      if (!f) return;
      f.resize();
      f.select(f.selectedIndex, false, true);
    } catch (e) {}
  }

  function temNome() {
    var n = document.querySelector('.mvn-costas__nome');
    var x = document.querySelector('.mvn-costas__numero');
    return !!((n && n.textContent.trim()) || (x && x.textContent.trim()));
  }

  function temEmblema() {
    return !!document.querySelector('.mvn-manga img, .mvn-peito img');
  }

  var pendente = null;
  function decidir() {
    clearTimeout(pendente);
    pendente = setTimeout(function () {
      if (temNome()) { mostrar(indiceCostas()); return; }
      if (temEmblema()) { mostrar(indiceFrente()); }
    }, 260);
  }

  /* O formulario e repintado a cada mudanca de variante, por isso ouve-se o
     documento inteiro em vez de se guardar referencias que morrem. */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('.mvn-perso')) decidir();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.mvn-perso')) decidir();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.mvn-perso')) decidir();
  }, true);

  /* E quando a personalizacao pinta a camada sozinha (jogador escolhido da
     lista, por exemplo) o clique acima nao chega: observa-se a galeria. */
  var alvo = document.querySelector('.product-images, .product-image-container');
  if (alvo && window.MutationObserver) {
    new MutationObserver(decidir).observe(alvo, { childList: true, subtree: true });
  }
})();

/* ------------------------------------------------------------
   Tamanhos em botoes, sem tirar o menu
   ------------------------------------------------------------
   O tema tem um modo proprio de mostrar as opcoes em botoes
   (`picker_type: button`), mas esse **troca os <select> por radios** e a
   personalizacao dos emblemas deixa de abrir: o `mvn-personalizacao.js`
   procura `select[name="options[...]"]` para saber quantos emblemas ha.
   Conferido no browser a 22/08: com `button`, carregar em «Add a badge» nao
   faz nada.

   Aqui os botoes sao desenhados por cima: o <select> continua a ser quem
   manda e quem guarda a escolha — carrega-se num botao e o menu muda.
   ------------------------------------------------------------ */
(function () {
  'use strict';

  function montar() {
    /* Todos os conjuntos de opcoes levam botoes — **menos** o do emblema, que
       a personalizacao ja substitui pela sua propria lista com fotografias.
       Reconhece-se pela vizinhanca (a lista vem logo a seguir), nunca pelo
       nome: a loja fala 18 linguas. */
    var campos = document.querySelectorAll('variant-selects .variations > fieldset');
    for (var k = 0; k < campos.length; k++) {
      var proximo = campos[k].nextElementSibling;
      if (proximo && proximo.classList && proximo.classList.contains('mvn-perso__badges')) continue;
      var s = campos[k].querySelector('select[name^="options"]');
      if (!s) continue;
      if (!s.dataset.mvnBotoes) fazer(s);
      else if (s.mvnSincronizar) s.mvnSincronizar();
    }
  }

  function fazer(sel) {
    sel.dataset.mvnBotoes = '1';

    var caixa = document.createElement('div');
    caixa.className = 'mvn-tamanhos';
    Array.prototype.forEach.call(sel.options, function (op) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mvn-tamanho';
      b.mvnOpcao = op;
      escrever(b, op);
      b.setAttribute('aria-pressed', op.selected ? 'true' : 'false');
      b.addEventListener('click', function () {
        var actual = b.mvnOpcao || op;          // a opcao de agora, nao a de entao
        sel.value = actual.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        pintar();
      });
      caixa.appendChild(b);
    });
    sel.parentNode.insertBefore(caixa, sel.nextSibling);

    function pintar() {
      var bs = caixa.querySelectorAll('.mvn-tamanho');
      for (var i = 0; i < bs.length; i++) {
        /* 25/08/2026 — **um botao a mais que o menu tem de sair.**
           O `mvn-personalizacao.js` tira o «Select player» do <select> quando a
           camisola nao tem plantel gravado, mas os botoes ja tinham sido
           desenhados: sobrava um, com o texto do vizinho, e via-se «Custom
           name» duas vezes. Acontecia nas 25 femininas e nas seleccoes novas.
           O <select> e quem manda: botao sem opcao correspondente desaparece. */
        if (!sel.options[i]) { bs[i].remove(); continue; }
        /* **E o botao tem de voltar a apontar para a opcao certa.** Guardava a
           que existia quando foi desenhado; tirada essa do menu, carregar nele
           punha o <select> num valor que ja nao ha — a variante deixava de ser
           encontrada e o «Add to cart» ficava morto. */
        bs[i].mvnOpcao = sel.options[i];
        /* opcao marcada pela personalizacao (o «Select player» sem plantel):
           o botao desaparece, mas a <option> fica no menu para o tema.
           **`hidden` sozinho nao chega** — o CSS do botao traz `display` e
           passa-lhe a frente; ficava a ver-se na mesma (25/08/2026). */
        var esconder = sel.options[i].dataset.mvnEscondido === '1';
        bs[i].hidden = esconder;
        bs[i].style.display = esconder ? 'none' : '';
        bs[i].setAttribute('aria-pressed', sel.options[i].value === sel.value ? 'true' : 'false');
        bs[i].disabled = sel.options[i].disabled;
        escrever(bs[i], sel.options[i]);
      }
    }
    sel.mvnSincronizar = pintar;
    sel.addEventListener('change', pintar);
    pintar();
  }

  /* ----------------------------------------------------------------
     O preco do extra tem de aparecer no botao
     ----------------------------------------------------------------
     22/08, reparo do dono: «preco no Select player falta estar visivel, e no
     de Custom name». O preco **ja la estava** — o `precosNoMenu()` do
     `mvn-personalizacao.js` escreve-o dentro da propria opcao, ja convertido
     para a moeda do pais («Select player (+$4.00)»). O que falhava era a
     ordem: os botoes sao desenhados por cima do menu e copiavam o texto da
     opcao **antes** de esse acrescento existir, ficando com o nome seco.

     Por isso o botao nao guarda um texto: guarda a **opcao**, e volta sempre a
     ler-lhe o texto. Assim tambem acompanha a mudanca de moeda e as 18 linguas
     sem se saber uma palavra de nenhuma.

     O acrescento sai do nome e vai para um `<small>` proprio, para poder ser
     mais pequeno e mais claro sem se tocar no nome da opcao. **Nao se procura
     a palavra «+»** — procura-se o pedaco entre parenteses no fim, que e como
     o `precosNoMenu()` o escreve, e o simbolo da moeda muda de pais para pais.
     ---------------------------------------------------------------- */
  function escrever(botao, op) {
    var t = (op.textContent || '').trim();
    if (botao.mvnTexto === t) return;   // nada mudou, nao se repinta
    botao.mvnTexto = t;
    var m = t.match(/^(.*?)\s*\(([^()]*)\)\s*$/);
    botao.textContent = m ? m[1] : t;
    if (m) {
      var extra = document.createElement('small');
      extra.className = 'mvn-tamanho__extra';
      extra.textContent = m[2];
      botao.appendChild(extra);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else { montar(); }
  /* o formulario e repintado a cada mudanca de variante */
  var alvo = document.querySelector('.product-information--inner');
  if (alvo && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(montar, 60); }).observe(alvo, { childList: true, subtree: true });
  }
})();

/* ------------------------------------------------------------
   «Choose a name below and it appears on the back»
   ------------------------------------------------------------
   So faz sentido onde a escrita sai mesmo — nao na NBA, nao nos produtos sem
   foto de tras. O criterio nao pode ser a palavra «back» no nome do ficheiro
   nem na legenda: a loja fala 18 linguas e as legendas sao traduzidas.
   O criterio certo e o que a propria personalizacao usa: se ela criou a
   camada do nome numa das fotos, entao ha costas. A frase vem escrita no
   template (para se poder traduzir na Shopify) e fica escondida ate aqui.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  function tratar() {
    var dica = document.querySelector('.mvn-galhint');
    if (!dica) return;
    var haCostas = !!document.querySelector('.mvn-costas__camada');
    if (!haCostas) { dica.hidden = true; return; }
    var galeria = document.querySelector('.product-image-container--thumbnails');
    if (galeria && dica.parentElement !== galeria) galeria.appendChild(dica);
    dica.hidden = false;
  }
  var t = null;
  function agendar() { clearTimeout(t); t = setTimeout(tratar, 400); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else { agendar(); }
  var alvo = document.querySelector('.product-images, .product-image-container');
  if (alvo && window.MutationObserver) {
    new MutationObserver(agendar).observe(alvo, { childList: true, subtree: true });
  }
  setTimeout(tratar, 2500);
})();

/* ------------------------------------------------------------
   «SAVE 39%» em vez de «SALE»
   ------------------------------------------------------------
   O modelo mostra a poupanca em percentagem, nao a palavra «SALE». O tema so
   escreve «SALE», e a percentagem tem de ser contada a partir dos dois precos
   que estao na pagina. Faz-se aqui e nao no Liquid porque o preco e reescrito
   a cada mudanca de variante — e a poupanca muda com ela.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  function numero(t) {
    if (!t) return 0;
    // 1.234,56 e 1,234.56 — fica so com digitos, e o ultimo separador manda
    var limpo = t.replace(/[^0-9.,]/g, '');
    var ultimo = Math.max(limpo.lastIndexOf('.'), limpo.lastIndexOf(','));
    if (ultimo > -1) {
      limpo = limpo.slice(0, ultimo).replace(/[.,]/g, '') + '.' + limpo.slice(ultimo + 1);
    }
    var n = parseFloat(limpo);
    return isNaN(n) ? 0 : n;
  }
  /* 23/08 — reparo dele: «fica a piscar o SALE para SAVE 2 ou 3 vezes».
     O tema volta a desenhar o bloco do preco varias vezes ao carregar a
     pagina, e de cada vez repunha «SALE»; nos corrigiamos 200 ms depois e
     via-se a troca. Agora:
       * o selo nasce invisivel pelo CSS e so aparece com `mvn-selo-pronto`;
       * a correccao e **imediata**, sem espera, no mesmo instante em que o
         tema mexe no bloco — assim nunca chega a ser pintado errado;
       * `pronto()` e chamado em **todas** as saidas, mesmo quando nao ha
         percentagem para contar, senao o selo ficava escondido para sempre. */
  function pronto(selo) { if (selo) selo.classList.add('mvn-selo-pronto'); }

  function tratar() {
    var caixa = document.querySelector('.product-price-container');
    if (!caixa) return;
    var selo = caixa.querySelector('.badge.onsale, .onsale');
    if (!selo) return;
    var velho = numero((caixa.querySelector('del') || {}).textContent);
    var novo = numero((caixa.querySelector('ins') || {}).textContent);
    if (!velho || !novo || novo >= velho) { pronto(selo); return; }
    var pc = Math.round((1 - novo / velho) * 100);
    if (pc < 1) { pronto(selo); return; }
    var texto = 'SAVE ' + pc + '%';
    if (selo.textContent.trim() !== texto) selo.textContent = texto;
    pronto(selo);
  }
  function agendar() { tratar(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else { agendar(); }
  var alvo = document.querySelector('.product-information--inner');
  if (alvo && window.MutationObserver) {
    new MutationObserver(agendar).observe(alvo, { childList: true, subtree: true, characterData: true });
  }
})();


/* ============================================================
   O preco do emblema no botao «Add a badge»            (23/08)
   ============================================================
   Reparo dele: «falta o preco no add a badge». Os quadrados de cada emblema
   ja o mostravam (`mvn-perso__badge-preco`), mas o botao que abre a lista
   nao — e e nele que se carrega primeiro.

   O valor **nao se escreve a mao**: sai do proprio bloco dos emblemas,
   `data-extra1`, que o `snippets/personalizacao.liquid` calcula pela
   diferenca de preco entre a variante sem emblema e a com emblema, e passa
   pelo filtro `money`. Por isso acompanha a moeda de cada pais (+2,99 EUR,
   +$4.00) sem se saber uma palavra de nenhuma lingua.

   Vai para um `<small>` proprio, com a mesma classe dos botoes de tamanho,
   para herdar o mesmo desenho: por baixo da palavra, mais pequeno e apagado.
   ============================================================ */
(function () {
  'use strict';

  function tratar() {
    var caixa = document.querySelector('[data-mvn-badges]');
    if (!caixa) return;
    var valor = caixa.dataset.extra1;
    if (!valor) return;
    var botao = caixa.querySelector('[data-mvn-badge-modo="sim"]');
    if (!botao) return;
    /* o tema volta a desenhar este bloco a cada mudanca de variante: se o
       `<small>` ja la esta com o valor certo, nao se toca em nada */
    var ja = botao.querySelector('.mvn-tamanho__extra');
    if (ja && ja.textContent === '+' + valor) return;
    if (ja) ja.parentNode.removeChild(ja);
    var extra = document.createElement('small');
    extra.className = 'mvn-tamanho__extra';
    extra.textContent = '+' + valor;
    botao.appendChild(extra);
  }

  var t = null;
  function agendar() { clearTimeout(t); t = setTimeout(tratar, 120); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else { agendar(); }
  var alvo = document.querySelector('.product-information--inner');
  if (alvo && window.MutationObserver) {
    new MutationObserver(agendar).observe(alvo, { childList: true, subtree: true });
  }
})();


/* ============================================================
   Estrelas e numero de opinioes                        (23/08)
   ============================================================
   Ele pediu o bloco do exemplo `01-mono.html`: as estrelas, a nota e o
   numero de opinioes com a palavra sublinhada, para **ver como fica** antes
   de ligar a aplicacao de opinioes.

   Por isso este bloco **nao aparece a quem compra**. So se desenha quando o
   endereco traz `?mvn_reviews=` — por exemplo
   `...?mvn_reviews=4.8,127`. Sem isso, a pagina fica exactamente como estava.
   A nota e a contagem sao as do endereco, nunca sao inventadas aqui.

   Quando a aplicacao de opinioes estiver ligada, ela escreve o metafield
   `reviews.rating` que este tema ja sabe ler sozinho (a
   `.star-rating-container`, que ja tem lugar guardado no `order:3`).
   Nessa altura este bloco todo pode desaparecer.
   ============================================================ */
(function () {
  'use strict';

  function pedido() {
    var m = location.search.match(/[?&]mvn_reviews=([^&]*)/);
    if (!m) return null;
    var p = decodeURIComponent(m[1]).split(',');
    var nota = parseFloat(p[0]);
    var quantas = parseInt(p[1], 10);
    if (isNaN(nota)) nota = 4.8;
    if (isNaN(quantas)) quantas = 127;
    return { nota: nota, quantas: quantas };
  }

  function montar() {
    var d = pedido();
    if (!d) return;
    var dentro = document.querySelector('.product-information--inner');
    if (!dentro || dentro.querySelector('.mvn-estrelas')) return;

    var linha = document.createElement('div');
    linha.className = 'mvn-estrelas';

    /* as cinco estrelas cheias ate a nota, e a ultima meia se sobrar meio
       ponto — desenhadas com o mesmo caracter do exemplo dele */
    var e = document.createElement('span');
    e.className = 'mvn-estrelas__i';
    e.setAttribute('aria-hidden', 'true');
    var cheias = Math.floor(d.nota);
    var meia = d.nota - cheias >= 0.25;
    var txt = '';
    for (var i = 0; i < 5; i++) txt += (i < cheias || (i === cheias && meia)) ? '★' : '☆';
    e.textContent = txt;
    linha.appendChild(e);

    var nota = document.createElement('span');
    nota.className = 'mvn-estrelas__nota';
    nota.textContent = d.nota.toFixed(1);
    linha.appendChild(nota);

    linha.appendChild(document.createTextNode('·'));

    var n = document.createElement('a');
    n.className = 'mvn-estrelas__n';
    n.href = '#mvn-opinioes';
    n.textContent = d.quantas + ' reviews';
    linha.appendChild(n);

    /* o aviso fica no titulo do link, para nao restar duvida de onde vieram
       estes numeros a quem esta a ver a pagina */
    linha.title = 'Pre-visualizacao: numeros do endereco, nao ha opinioes reais.';

    dentro.appendChild(linha);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else { montar(); }
})();
